import React from 'react'
import {KTSVG} from '../../../../_metronic/helpers/components/KTSVG'

function GroupTabContentBar({title, searchTerm, setSearchTerm, setAction}: any) {
  return (
    <div className='row'>
      <div className='d-flex flex-column flex-md-row justify-content-sm-between'>
        <div className='d-flex flex-column w-md-50'>
          <h2>{title}</h2>

          <div className='d-flex mt-2 bg-light align-items-center w-100 w-xl-450px rounded position-relative square border border-secondary'>
            <KTSVG
              path='/media/icons/duotune/general/gen021.svg'
              className='svg-icon-1 position-absolute ms-5'
            />
            <input
              type='text'
              data-kt-user-table-filter='search'
              className='form-control form-control-solid ps-14'
              placeholder={`Search ${title}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className='d-flex flex-row flex-wrap'>
          <button
            type='button'
            className='btn  btn-light square border border-dark m-2 h-45px'
            onClick={() => setAction(true)}
          >
            <i className='fa-solid fa-rotate-right' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default GroupTabContentBar
